exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-main[data-v-5ea36fec]  .page-card .page-card_head{border-bottom:none}.page-main[data-v-5ea36fec]  .page-card .page-card_body{padding-top:0}.page-main .add-header[data-v-5ea36fec]{padding:.24 rem .32 rem;border-bottom:1 px solid #f0f0f0;font-size:.22rem;font-weight:bold;margin:.24rem 0}", ""]);

// exports
